import type { FC } from "react";
import {
  ApacFlightsComponent,
  type CustomerSupportModalContentProps,
} from "@apac/components/flights";
import { useModuleBEM } from "@b2bportal/core-themes";
import { phoneWithSupportIdIfEnabled } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useApacFlightsStyles } from "../../hooks";
import defaultStyles from "./CustomerSupportModalContent.module.scss";

const COMPONENT_KEY = ApacFlightsComponent.CustomerSupportModalContent;

export const CustomerSupportModalContent: FC<
  CustomerSupportModalContentProps
> = ({ bookingSupportId }) => {
  const { t, brand: branding } = useI18nContext();
  const styles = useApacFlightsStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const hideSupportId = branding.contactSupport.hideSupportIdInContactSupport;
  const supportPhone = phoneWithSupportIdIfEnabled(
    hideSupportId,
    branding.contactSupport.supportNumber,
    bookingSupportId
  );
  const supportPhoneIntl = phoneWithSupportIdIfEnabled(
    hideSupportId,
    branding.contactSupport.intlSupportNumber,
    bookingSupportId
  );

  return (
    <div className={cn("call-modal-content")}>
      <div className={cn("call-modal-text")}>
        {t("customerSupportPage.landingPage.speakDialogCopy")}
      </div>

      {!hideSupportId ? (
        <div className={cn("support-id")}>{`${t(
          "customerSupportPage.landingPage.supportId"
        )}: ${bookingSupportId}`}</div>
      ) : null}

      <div className={cn("call-modal-text")}>
        <span>{t("customerSupportPage.landingPage.phoneDomesticCopy")}</span>
        <a href={`tel:${supportPhone}`}>
          {branding.contactSupport.displaySupportNumber}
        </a>
      </div>

      <div className={cn("call-modal-text")}>
        <span>
          {t("customerSupportPage.landingPage.phoneInternationalCopy")}
        </span>
        <a href={`tel:${supportPhoneIntl} `}>
          {branding.contactSupport.displayIntlSupportNumber}
        </a>
      </div>
    </div>
  );
};
